import type { ReactNode } from 'react';
import { Montant, type Barre } from '../../../composants/ui/index.ts';

/**
 * CA des sept derniers jours, en barres VERTICALES — comme une rangée de
 * jetons sur un registre, pas un histogramme saturé de couleur. Un seul
 * accent marque aujourd'hui ; les autres jours restent neutres.
 */
export function BlocJours({ barres }: { barres: Barre[] }): ReactNode {
  const plusHaute = Math.max(1, ...barres.map((barre) => barre.valeur));
  const aujourdhui = barres.find((barre) => barre.aujourdhui);

  return (
    <section className="carte tdb-bloc">
      <header className="tdb-bloc__tete">
        <div>
          <h2>Chiffre d’affaires, 7 derniers jours</h2>
          <p className="tdb-bloc__sous">Rapporté au meilleur jour de la semaine</p>
        </div>
        {aujourdhui !== undefined && (
          <span className="tdb-bloc__note">
            <Montant valeur={aujourdhui.valeur} /> aujourd’hui
          </span>
        )}
      </header>

      <div className="tdb-semaine">
        {barres.map((barre, index) => {
          // Un jour à peine vendu garde une barre visible : à zéro pixel,
          // on ne distingue plus « rien vendu » de « donnée manquante ».
          const hauteur = barre.valeur > 0 ? Math.max((barre.valeur * 100) / plusHaute, 4) : 0;
          return (
            <div
              key={`${barre.libelle}-${String(index)}`}
              className={barre.aujourdhui ? 'tdb-semaine__jour tdb-semaine__jour--auj' : 'tdb-semaine__jour'}
              title={`${barre.libelle} : ${String(barre.valeur)} F`}
            >
              <div className="tdb-semaine__barre" style={{ height: `${String(hauteur)}%` }} />
            </div>
          );
        })}
      </div>
      <div className="tdb-semaine__libelles">
        {barres.map((barre, index) => (
          <span
            key={`${barre.libelle}-lib-${String(index)}`}
            className={barre.aujourdhui ? 'tdb-semaine__auj' : undefined}
          >
            {barre.libelle}
          </span>
        ))}
      </div>
    </section>
  );
}
